import { render } from "./MetricAdditionDetails.vue?vue&type=template&id=967d610e"
import script from "./MetricAdditionDetails.vue?vue&type=script&lang=js"
export * from "./MetricAdditionDetails.vue?vue&type=script&lang=js"

import "./MetricAdditionDetails.vue?vue&type=style&index=0&id=967d610e&lang=css"

import exportComponent from "/Users/abinop/code/Filisia-Dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__